import { Injectable } from '@angular/core';

import { GetPaginationRes } from '@hglobal/fin-ui';
import { Observable } from 'rxjs';

import { SupportIssueType } from '@zeusm/business/core/entities';
import type { Rates } from '@zeusm/business/core/entities';

import { ShellApi } from './shell-api.interface';
import { ApiSettings, ConditionsResponse } from '../entities';
import {
  conditionsMock,
  cryptoMarketMock,
  getRatesResMock,
  hasAgentAccountsMock,
  mockResponse,
  settingsMock,
  supportLinkMock,
  telegramLinkMock,
  totalBalanceMock,
} from '../mocks/shell.mock';

@Injectable()
export class ShellApiMockService implements ShellApi {
  getRates(): Observable<GetPaginationRes<Rates>> {
    return mockResponse(getRatesResMock());
  }

  getCryptoMarket(): Observable<GetPaginationRes<any>> {
    return mockResponse(cryptoMarketMock);
  }

  getTotalBalance(_currencyId: number): Observable<string> {
    return mockResponse(totalBalanceMock);
  }

  getSettings(): Observable<ApiSettings> {
    return mockResponse(settingsMock);
  }

  getHasAgentAccounts(_payload: { orgId: string }): Observable<boolean> {
    return mockResponse(hasAgentAccountsMock);
  }

  getConditions(): Observable<ConditionsResponse> {
    return mockResponse(conditionsMock);
  }

  generateTelegramLink(): Observable<string> {
    return mockResponse(telegramLinkMock);
  }

  getSupportLink(_issueType: SupportIssueType): Observable<{ url: string }> {
    return mockResponse(supportLinkMock);
  }
}
